// @flow
import React from 'react';
import PropTypes from 'prop-types';
import { Route } from 'react-router';

import type { Node } from 'react';

type Props = {
  code: number;
  children: Node;
};

export const Status = ({ code, children }: Props) => (
  <Route render={({ staticContext }) => {
    if (staticContext) {
      staticContext.status = code;
    }
    return children;
  }}/>
);

Status.propTypes = {
  code: PropTypes.number.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};



// WEBPACK FOOTER //
// ./src/router/Status.jsx